import React from 'react';
import ScoreMetric from './ScoreMetric';
import { Card, CardContent } from '@/components/ui/card';
import { Heading, Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

function TestScoreCard({ data, type,tt }) {
  if (!data) return null;

  const { title, score, confidenceScore, domainScore, metrics } = data;
  const getColorFromScore = (score) => {
    score = parseInt(score, 10);
    if (score >= 9 && score <= 10) return "rgba(7, 136, 0, 1)";
    if (score >= 8 && score < 9) return "rgba(14, 181, 5, 1)";
    if (score >= 7 && score < 8) return "rgba(75, 94, 195, 1)";
    if (score >= 5 && score < 7) return "rgba(255, 244, 117, 1)";
    if (score >= 4 && score < 5) return "pink";
    return "orange";
  };

  const isNotScheduled = metrics.every(metric => metric.score === "null/10");

  return (
    <div className={`test-score-cardd ${isNotScheduled ? "not-scheduled" : ""}`}>
      {isNotScheduled && (
  <div className="watermark">
    {tt ? `Scheduled on ${tt}` : "Not Scheduled"}
  </div>
)}



      <h2>{title}</h2>

      <div className={`score-section ${isNotScheduled ? "dimmed" : ""}`}>
        {type === "screening" && (
          <>
            <h3>Overall Score</h3>
            <div className="score-value1">{score || "N/A"}</div>
            <h3>Confidence Score</h3>
            <div className="score-value2">{confidenceScore || "N/A"}</div>
            <h3>Domain Based Score</h3>
            <div className="score-value3">{domainScore || "N/A"}</div>
          </>
        )}
      </div>

      <h3>Test Breakdown</h3>
      <div className={`metrics ${isNotScheduled ? "dimmed" : ""}`}>
        {metrics.length > 0 ? (
          metrics.map((metric, index) => (
            <ScoreMetric
              key={index}
              name={metric.name}
              score={metric.score}
              percentage={metric.percentage}
              color={getColorFromScore(metric.score)}
            />
          ))
        ) : (
          <p>No metrics available</p>
        )}
      </div>
    </div>
  );
}

export default TestScoreCard;
